<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline pt-1 pr-1 custom-card-header">
          Confirm Archive
          <v-spacer></v-spacer>
          <v-btn icon @click="toggle"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <br />
        <v-card-text class="pb-1"> Are you sure you want to archive this staff member?</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="ma-2" @click="archive">Archive</v-btn>
          <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    user: {
      type: Object
    }
  },
  methods: {
    ...mapActions({
      archiveUser: 'user/archiveUser'
    }),
    async archive () {
      await this.archiveUser(this.user)
      this.toggle()
    }
  }
}
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
